<template>
  <div class="alarm-page">
    <div class="alarm-card">
      <div class="alarm-header">
        <div class="alarm-title">告警设置</div>
        <div class="alarm-divider"></div>
        <div class="alarm-toolbar">
          <div class="alarm-actions">
            <el-button size="small" class="alarm-btn-add" @click="openAddDialog"><i class="el-icon-plus"></i>添加告警设置</el-button>
            <el-button size="small" class="alarm-btn-refresh" title="刷新" @click="fetchData"><i class="el-icon-refresh"></i></el-button>
          </div>
          <div class="alarm-search-group">
            <el-input v-model="searchForm.keyword" size="small" clearable placeholder="请输入" class="alarm-search-input" @keyup.enter.native="handleSearch" />
            <el-button size="small" type="primary" class="alarm-search-btn" @click="handleSearch">搜索</el-button>
          </div>
        </div>
      </div>

      <div class="alarm-table-section">
        <el-table v-loading="loading" :data="tableData" style="width: 100%" :header-cell-style="headerCellStyle" :cell-style="cellStyle">
          <el-table-column prop="communityName" label="所在小区" min-width="150" show-overflow-tooltip />
          <el-table-column prop="alarmTypeName" label="告警类型" min-width="120" show-overflow-tooltip />
          <el-table-column prop="handleTime" label="办理时长" min-width="100">
            <template slot-scope="scope">{{ scope.row.handleTime }}分钟</template>
          </el-table-column>
          <el-table-column prop="returnVisitFlag" label="是否回访" min-width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.returnVisitFlag === 'Y' ? '是' : '否' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="overtimeWarning" label="超时预警" min-width="100">
            <template slot-scope="scope">{{ scope.row.overtimeWarning ? scope.row.overtimeWarning + '分钟' : '-' }}</template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" min-width="160" show-overflow-tooltip />
          <el-table-column label="操作" min-width="200" fixed="right">
            <template slot-scope="scope">
              <div class="action-group">
                <a class="action-link" @click="openEditDialog(scope.row)">修改</a>
                <a class="action-link" @click="viewHandlers(scope.row)">绑定处理人员</a>
                <a class="action-link danger" @click="openDeleteDialog(scope.row)">删除</a>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="alarm-pagination">
        <span class="pagination-total">共{{ pagination.total }}条</span>
        <el-pagination
          :current-page="pagination.page"
          :page-size="pagination.size"
          layout="prev, pager, next"
          :total="pagination.total"
          @current-change="handlePageChange"
        />
        <span class="pagination-size-text">{{ pagination.row }}条/页</span>
      </div>
    </div>

    <add-alarm-setting ref="addDialog" @success="fetchData" />
    <edit-alarm-setting ref="editDialog" @success="fetchData" />
    <delete-alarm-setting ref="deleteDialog" @success="fetchData" />
  </div>
</template>

<script>
import { listAlarmSettings } from '@/api/inspection/alarmSettingManageApi'
import AddAlarmSetting from '@/components/inspection/AddAlarmSetting'
import EditAlarmSetting from '@/components/inspection/EditAlarmSetting'
import DeleteAlarmSetting from '@/components/inspection/DeleteAlarmSetting'

export default {
  name: 'AlarmSettingList',
  components: { AddAlarmSetting, EditAlarmSetting, DeleteAlarmSetting },
  data() {
    return {
      loading: false,
      searchForm: { keyword: '' },
      tableData: [],
      pagination: { page: 1, row: 10, size: 10, total: 0 }
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loading = true
      try {
        const params = { page: this.pagination.page, row: this.pagination.row }
        if (this.searchForm.keyword) params.keyword = this.searchForm.keyword
        const res = await listAlarmSettings(params)
        console.log('告警设置列表数据:', res.data) // 调试用
        this.tableData = res.data
        this.pagination.total = res.total

        // 如果当前页没有数据且不是第一页，自动跳转到上一页
        if (this.tableData.length === 0 && this.pagination.page > 1) {
          this.pagination.page--
          this.fetchData()
        }
      } catch (error) {
        this.$message.error(error.message || '获取列表失败')
      } finally {
        this.loading = false
      }
    },
    handleSearch() { this.pagination.page = 1; this.fetchData() },
    handlePageChange(page) { this.pagination.page = page; this.fetchData() },
    openAddDialog() { this.$refs.addDialog.open() },
    openEditDialog(row) { this.$refs.editDialog.open(row) },
    openDeleteDialog(row) { this.$refs.deleteDialog.open(row) },
    viewHandlers(row) {
      this.$router.push({
        path: '/pages/inspection/alarmHandlerList',
        query: {
          alarmTypeCd: row.alarmTypeCd,
          communityId: row.communityId
        }
      })
    },
    headerCellStyle() { return { background: '#F5F8FC', color: '#6A7282', fontWeight: 500, fontSize: '13px', borderBottom: 'none', height: '48px' } },
    cellStyle({ rowIndex }) { return { background: rowIndex % 2 === 1 ? '#F8FBFF' : '#FFFFFF', color: '#333333', fontSize: '14px', borderBottom: '1px solid #F0F4FA', height: '52px' } }
  }
}
</script>

<style scoped>
.alarm-page { height: calc(100vh - 60px); background: #EBF2FA; padding: 16px; overflow: hidden; display: flex; flex-direction: column; }
.alarm-card { background: #FFFFFF; border-radius: 12px; box-shadow: 0 2px 8px rgba(0,0,0,0.06); display: flex; flex-direction: column; height: 100%; overflow: hidden; }
.alarm-header { padding: 24px 24px 0; flex-shrink: 0; }
.alarm-title { font-size: 18px; font-weight: 600; color: #1D2129; line-height: 26px; }
.alarm-divider { height: 1px; background: #DCE6F5; margin: 16px 0; }
.alarm-toolbar { display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px; }
.alarm-actions { display: flex; gap: 8px; }
.alarm-btn-add { background: #0E76FF; color: #FFFFFF; border: none; border-radius: 10px; height: 36px; padding: 0 16px; font-weight: 500; }
.alarm-btn-add:hover { background: #0D6CE8; }
.alarm-btn-refresh { width: 36px; height: 36px; padding: 0; border-radius: 10px; border: 1px solid #DCE6F5; background: #FFFFFF; color: #6A7282; }
.alarm-btn-refresh:hover { background: #F5F8FC; }
.alarm-search-group { display: flex; gap: 8px; }
.alarm-search-input { width: 200px; }
.alarm-search-btn { height: 36px; padding: 0 20px; border-radius: 10px; }
.alarm-table-section { flex: 1; overflow: auto; padding: 0 24px; }
.action-group { display: flex; align-items: center; gap: 12px; }
.action-link { color: #0E76FF; cursor: pointer; font-size: 14px; text-decoration: none; }
.action-link:hover { text-decoration: underline; }
.action-link.danger { color: #F53F3F; }
.alarm-pagination { display: flex; align-items: center; justify-content: flex-end; gap: 16px; padding: 16px 24px; border-top: 1px solid #F0F4FA; flex-shrink: 0; }
.pagination-total { color: #6A7282; font-size: 14px; }
.pagination-size-text { color: #6A7282; font-size: 14px; }
</style>
